import { atom } from "recoil";

export const drawerState = atom<boolean>({
  key: 'filterDrawerState',
  default: false,
});